// extracted by mini-css-extract-plugin
export default {"loginType":"loginType_loginType__orIRr","loginType__external":"loginType_loginType__external__EhKHe"};